import { render, staticRenderFns } from "./PaymentModals.vue?vue&type=template&id=8130ee18&lang=pug&"
import script from "./PaymentModals.vue?vue&type=script&lang=js&"
export * from "./PaymentModals.vue?vue&type=script&lang=js&"
import style0 from "./PaymentModals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8130ee18')) {
      api.createRecord('8130ee18', component.options)
    } else {
      api.reload('8130ee18', component.options)
    }
    module.hot.accept("./PaymentModals.vue?vue&type=template&id=8130ee18&lang=pug&", function () {
      api.rerender('8130ee18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayouts/PaymentModals.vue"
export default component.exports